import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { DealershipCapacityComponent } from './dealership-capacity.component';
import { DeactivateGuard } from '../../shared/guards/candeactivate';


const routes: Routes = [
    {
        path: '',
        component: DealershipCapacityComponent,
        canDeactivate:[DeactivateGuard]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class DealershipCapacityRoutingModule { }
